export default __webpack_public_path__ + "images/no_orders.svg";